// extracted by mini-css-extract-plugin
export default {"info":"style_info__3-H8q","spinner":"style_spinner__uxxeP"};